import React, { Component } from 'react';
import SVipAccessFlow from 'shared/screens/VipAccessFlow';
import './VipAccessFlow.scss';
import Utils from 'shared/utils/index';
import ENVIRONMENT_VARIABLES from 'shared/utils/environmentVariables';
import { getText, TEXT_KEY } from 'shared/utils/localization';
import { BUTTON_STROKES } from 'shared/utils/buttonTextStrokes';
import Button from '../../components/Button/Button';
import { ThemeContext } from 'styled-components';
import VipAccessHeader from './components/VipAccessHeader';
import { VipAccessHaderTitle } from './components/styledComponents';
import { ASSET_KEY, assetSource } from 'shared/utils/assetSource';

const hasVIPPass = playNow => {
  return (
    <div className="vipAccessContainer">
      <div className={'vipAccessInfo' + (Utils.ieVersion() !== 0 ? ' ieHack' : '')}>
        <div className="hasVipAccess">
          <img src={assetSource(ASSET_KEY.PROMOTIONAL_GRAPHIC)} alt="VIP Access" />
        </div>
        <p className="vipAccessSubtitle">
          <img alt="" src={assetSource(ASSET_KEY.LIGHT_DIVIDER)} />
          {getText(TEXT_KEY.ALREADY_HAVE_VIP_ACCESS_FULL_TEXT)}
        </p>
      </div>
      <Button
        imageSource={assetSource(ASSET_KEY.ROUNDED_RECT_PRIMARY)}
        containerStyle={{ width: '100%', padding: '2rem' }}
        onClick={playNow}
        label={getText(TEXT_KEY.PLAY_NOW)}
      />
    </div>
  );
};

const VIPAccessNeeded = (purchaseVipAccess, redeemVipAccess, enterRequirements, themeContext) => {
  const itemCount = enterRequirements?.length;
  return (
    <div className="vipAccessContainer">
      <VipAccessHeader
        titleStyle={VipAccessHaderTitle}
        title={`${getText(TEXT_KEY.VIP)} ${getText(TEXT_KEY.VIP_ACCESS_NEEDED)}`}
      />
      <div className={'vipAccessInfo' + (Utils.ieVersion() !== 0 ? ' ieHack' : '')}>
        <p className="vipAccessSubtitle">
          <img alt="" src={assetSource(ASSET_KEY.LIGHT_DIVIDER)} />
          {getText(TEXT_KEY.VIP_ACCESS_WAYS)}
        </p>
        <div className="vipAccessSteps">
          {ENVIRONMENT_VARIABLES.DYNAMIC_HIGHLIMIT_POPUP &&
          ENVIRONMENT_VARIABLES.DYNAMIC_HIGHLIMIT_POPUP.toString() === 'true' ? (
            enterRequirements.map(requirement => (
              <div
                key={requirement.icon}
                style={
                  itemCount === 2
                    ? themeContext.VipAccessFlow.VipAccessTwoImagesWrapper
                    : themeContext.VipAccessFlow.VipAccessMultipleImageWrapper
                }
              >
                <img src={requirement.icon} alt="VIP Access options" />
              </div>
            ))
          ) : (
            <img
              style={themeContext.VipAccessFlow.VipAccessImage}
              src={assetSource(ASSET_KEY.ACCEPT_BUTTON)}
              alt="VIP Access options"
            />
          )}
        </div>
      </div>
      <div className={'vipAccessButtons' + (Utils.ieVersion() !== 0 ? ' ieHack' : '')}>
        <Button
          containerStyle={{ width: '28%', marginBottom: '1.5rem', marginTop: '1rem' }}
          imageSource={assetSource(ASSET_KEY.ROUNDED_RECT_PRIMARY)}
          imageStyle={themeContext.VipAccessFlow.VipAccessButtonImage}
          label={getText(TEXT_KEY.PURCHASE_ACCESS)}
          onClick={purchaseVipAccess}
          textStyle={themeContext.VipAccessFlow.VipAccessButtonText}
          textStroke={BUTTON_STROKES.PRIMARY}
        />
        <Button
          imageSource={assetSource(ASSET_KEY.ROUNDED_RECT_QUATERNARY)}
          textStroke={BUTTON_STROKES.QUATERNARY}
          imageStyle={themeContext.VipAccessFlow.VipAccessButtonImage}
          containerStyle={{ width: '28%', marginBottom: '1.5rem', marginTop: '1rem' }}
          label={getText(TEXT_KEY.REDEEM_ACCESS)}
          onClick={redeemVipAccess}
          textStyle={themeContext.VipAccessFlow.VipAccessRedeemButtonText}
        />
      </div>
    </div>
  );
};

export default class VipAccessFlow extends Component {
  static get AsModalProps() {
    return {
      dialogClassName: 'gtp-modal-vip-access',
    };
  }

  render() {
    return (
      <SVipAccessFlow
        navigation={this.props.navigation}
        {...this.props}
        render={args => {
          const themeContext = this.context;
          const { purchaseVipAccess, redeemVipAccess, playNow, isVipRoomUnlocked, enterRequirements } = args;
          return (
            <div>
              {isVipRoomUnlocked
                ? hasVIPPass(playNow)
                : VIPAccessNeeded(purchaseVipAccess, redeemVipAccess, enterRequirements, themeContext)}
            </div>
          );
        }}
      />
    );
  }
}

VipAccessFlow.contextType = ThemeContext;

